export default {
  catSubjectDomains: {},
  catStats: {},
  catSubjectDomainsPosition: {},
};



// WEBPACK FOOTER //
// ./src/app/cat-domain/store/state.js